import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const SummitAgendaBlock = ({
  key,
  summitDayBreakdown=null
}) => {
  return (
    <div className="col-12 summit-agenda-block">
      {summitDayBreakdown.map((day) => (
        <div className="agenda-block">
          <div className="agenda-block__header">
            <div className="container">
              {day.dayTitle &&
                <h2 className="agenda-block__title">{ htmlDecode(day.dayTitle) }</h2>
              }
            </div>
          </div>
          <div className="d-none d-md-block">
            {day.timeBlock && day.timeBlock.map((block) => (
              <div className="agenda-block__time-blocks">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-lg-6 ph0 d-flex flex-wrap">
                      <div className="col-12 col-lg-5">
                        {(block.startTime || block.endTime) &&
                          <h3 className="time">
                            {block.startTime &&
                              <>
                                { htmlDecode(block.startTime) }
                              </>
                            }
                            {block.endTime &&
                              <>
                                &nbsp;-&nbsp;
                                { htmlDecode(block.endTime) }
                              </>
                            }
                          </h3>
                        }
                      </div>
                      <div className="col-12 col-lg-7">
                        {block.dayTitle &&
                          <h3>{ htmlDecode(block.dayTitle) }</h3>
                        }
                        {block.daySubTitle &&
                          <h4>{ htmlDecode(block.daySubTitle) }</h4>
                        }
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 time-block-content">
                      {block.dayContent &&
                        <div dangerouslySetInnerHTML={{ __html: block.dayContent }} />
                      }
                      {block.speakers &&
                        <>
                          <p className="mb0"><strong>Speaker(s):</strong></p>
                          <div className="mb0" dangerouslySetInnerHTML={{ __html: block.speakers }} />
                        </>
                      }
                      {block.facilitators &&
                        <>
                          <p className="mb0"><strong>Facilitator(s):</strong></p>
                          <div className="mb0" dangerouslySetInnerHTML={{ __html: block.facilitators }} />
                        </>
                      }
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="d-block d-md-none">
            {day.timeBlock && day.timeBlock.map((block, index) => (
              <div className="accordion" id={ `accordion-${index}` }>
                <div className="card xbrdr xbr mb-3">
                  <div className="card-header xbrdr xp xbg" id={ `heading-${index}` }>
                    <h5 className="mb-0">
                      <button className="btn btn-link btn-level-1 collapsed col-16" type="button" data-toggle="collapse" data-target={ `#collapse-${index}` } aria-expanded="false" aria-controls={ `collapse-${index}` }>
                        <div className="col-10">
                          {(block.startTime || block.endTime) &&
                            <span><strong>
                              {block.startTime &&
                                <>
                                  { htmlDecode(block.startTime) }
                                </>
                              }
                              {block.endTime &&
                                <>
                                  &nbsp;-&nbsp;
                                  { htmlDecode(block.endTime) }
                                </>
                              }
                              <br />
                            </strong></span>
                          }
                          {block.dayTitle &&
                            <span className="small">
                              { htmlDecode(block.dayTitle) }
                              {block.daySubTitle &&
                                <>
                                  &nbsp;|&nbsp;
                                  { htmlDecode(block.daySubTitle) }
                                </>
                              }
                            </span>
                          }
                        </div>
                        <div className="col-2 justify-content-end d-flex">
                          <i className="fa fa-plus">&nbsp;</i>
                        </div>
                      </button>
                    </h5>
                  </div>
                  <div id={ `collapse-${index}` } className="collapse" aria-labelledby={ `heading-${index}` } data-parent={ `#accordion-${index}` }>
                    <div className="card-body text-left pt1">
                      {block.dayContent &&
                        <div dangerouslySetInnerHTML={{ __html: block.dayContent }} />
                      }
                      {block.speakers &&
                        <>
                          <p className="mb0"><strong>Speaker(s):</strong></p>
                          <div className="mb0" dangerouslySetInnerHTML={{ __html: block.speakers }} />
                        </>
                      }
                      {block.facilitators &&
                        <>
                          <p className="mb0"><strong>Facilitator(s):</strong></p>
                          <div className="mb0" dangerouslySetInnerHTML={{ __html: block.facilitators }} />
                        </>
                      }
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default SummitAgendaBlock
